const INTERNET_MESSAGE_ID_PATTERN = /^<?[^<>\s]+@[^<>\s]+>?$/;
export const isInternetMessageId = (id) => typeof id === 'string' && INTERNET_MESSAGE_ID_PATTERN.test(id);

// Sanitize all RegExp special characters
export const sanitizeString = (str) => str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

export const convertToText = (input) => {
  if (typeof input === 'string') {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || '';
  } else if (typeof input === 'object' && input.$$typeof === Symbol.for('react.element')) {
    // Handle React elements
    return input.props.children;
  } else {
    // Handle other data types or unknown cases
    return input;
  }
};

/**
 * Removes empty strings from an object
 * @param {object} obj
 * @return {object} object with empty strings removed
 */
export const removeEmptyStrings = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, val]) => val !== ''));
};

